import { BrowserId } from 'Browser/BrowserId';
import { Environment } from 'Common/Environment';
import { SiteBasics } from 'Common/SiteBasics';
import { Urls } from 'Common/Urls';
import {createContext,JSX,useContext} from 'solid-js';
import Assert from 'Common/Assert';

interface IUrlProvider {
	build: Environment;
	site: SiteBasics<BrowserId>;
}

const UrlContext = createContext<IUrlProvider>();

export function UrlProvider(P:IUrlProvider & {children:JSX.Element})
{
	return (
		<UrlContext.Provider value={P}>
			{P.children}
		</UrlContext.Provider>
	);
}

export function useUrls()
{
	const context = Assert.have(useContext(UrlContext));
	return new Urls(context.build,context.site);
}

// Like useUrls(), but returns a factory that builds a fresh Urls each call.
// Capture this once during component setup (it reads the context here, under an
// owner), then call the returned function later — e.g. inside an event handler —
// to get a Urls reflecting the *current* site. This matters when the site key
// arrives asynchronously (see PosterPage): a useUrls() snapshot taken at mount
// would freeze an undefined key, whereas re-evaluating context.site picks it up.
export function useUrlsFactory()
{
	const context = Assert.have(useContext(UrlContext));
	return () => new Urls(context.build,context.site);
}


